import { createTransitOperationInfoV2 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function createTransitOperationInfo(transitOperationId: number) {
  if (transitOperationId === null || transitOperationId === undefined) {
    throw new Error('Transit Operation ID cannot be null or undefined!')
  }
  return createTransitOperationInfoV2({ transitOperationId })
}
